import MetaTitle from "./MetaTitle";

export default MetaTitle;
